import Cookies from 'js-cookie'

const accessToken = '__access_token'

// 修复 cookie 跨域问题

export function getAccessToken() {
  return Cookies.get(accessToken)
}

export function setAccessToken(token) {
  return Cookies.set(accessToken, token)
}

export function removeAccessToken() {
  return Cookies.remove(accessToken)
}
